import { Component } from '@theme/component';

const CATEGORIES = ['signature', 'series', 'ambassadors'];

/**
 * @typedef {Object} Refs
 * @property {HTMLButtonElement[]} [filterButtons]
 * @property {HTMLElement[]} [cards]
 *
 * @extends {Component<Refs>}
 */
class ArtistsFilterGridComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#syncState();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#syncState();
  }

  get buttons() {
    return /** @type {HTMLButtonElement[]} */ (this.refs.filterButtons || []);
  }

  get cards() {
    return /** @type {HTMLElement[]} */ (this.refs.cards || []);
  }

  /**
   * @param {MouseEvent} event
   */
  handleFilterClick = (event) => {
    const target = event.target;

    if (!(target instanceof HTMLElement)) return;

    const category = target.dataset.category;

    if (!category || !CATEGORIES.includes(category)) return;

    this.selectCategory(category);
  };

  /**
   * @param {string} category
   */
  selectCategory(category) {
    if (!CATEGORIES.includes(category)) return;

    this.dataset.activeCategory = category;

    for (const button of this.buttons) {
      const isActive = button.dataset.category === category;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    }

    for (const card of this.cards) {
      card.classList.toggle('hidden', card.dataset.category !== category);
    }
  }

  #syncState() {
    const category = this.#resolveInitialCategory();
    this.selectCategory(category);
  }

  #resolveInitialCategory() {
    const requestedCategory = this.dataset.activeCategory;

    if (requestedCategory && CATEGORIES.includes(requestedCategory)) {
      return requestedCategory;
    }

    const availableCategories = new Set(
      this.cards.map((card) => card.dataset.category).filter(Boolean)
    );

    return CATEGORIES.find((category) => availableCategories.has(category)) || CATEGORIES[0];
  }
}

if (!customElements.get('artists-filter-grid-component')) {
  customElements.define('artists-filter-grid-component', ArtistsFilterGridComponent);
}
